import { lazy, Suspense } from 'react';
import { Outlet, createRoute } from '@tanstack/react-router';

import DashboardLayout from 'src/layouts/dashboard';

import AppAuthGuard from 'src/components/auth/app-auth-guard';
import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { rootRoute } from './root';

const Checkout = lazy(() => import('src/sections/checkout/view'));
const ReviewOrder = lazy(() => import('src/sections/checkout/review-order/view'));
const OrderCreated = lazy(() => import('src/sections/checkout/order-created/view'));
// Checkout routes
const checkoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'checkout',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AppAuthGuard>
  ),
});

const checkoutIndexRoute = createRoute({
  getParentRoute: () => checkoutRoute,
  path: '/',
  component: Checkout,
});

const reviewOrderRoute = createRoute({
  getParentRoute: () => checkoutRoute,
  path: 'review-order',
  component: ReviewOrder,
});

const orderCreatedRoute = createRoute({
  getParentRoute: () => checkoutRoute,
  path: 'success',
  component: OrderCreated,
});

export const checkoutRouteTree = checkoutRoute.addChildren([
  checkoutIndexRoute,
  reviewOrderRoute,
  orderCreatedRoute,
]);
